import React from 'react';
import { styled } from '@mui/material/styles';

interface Props {
  children: React.ReactNode;
}

const Root = styled('div')(({ theme }) => ({
  width: '100%',
  overflowX: 'initial',
  backgroundColor: theme.palette.common.white,
  marginBottom: '2rem',
}));

const Container = ({ children }: Props) => {
  return <Root aria-label="Container">{children}</Root>;
};

export default Container;
